import { apiInstance, legacyV2Path } from '../index'
import { mapArgs } from 'corp-front-vue-commons/src/utils/functions'

const timePolicy = {
  get (...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: `${legacyV2Path()}/PATH`,
      params
    })
  },

  getById (id) {
    return apiInstance({
      method: 'GET',
      url: `${legacyV2Path()}/timepolicy/${id}/costcenter`
    })
  },

  create (data) {
    return apiInstance({
      method: 'POST',
      url: `${legacyV2Path()}/PATH`,
      data
    })
  },

  update (id, data) {
    return apiInstance({
      method: 'PUT',
      url: `${legacyV2Path()}/PATH/${id}`,
      data
    })
  },

  delete (id) {
    return apiInstance({
      method: 'DELETE',
      url: `${legacyV2Path()}/PATH/${id}`
    })
  },

  getCostCenterById (timePolicyId) {
    return apiInstance({
      method: 'GET',
      url: `${legacyV2Path()}/timepolicy/${timePolicyId}/costcenter`
    })
  }
}

export default timePolicy
